import React, { useRef, useState } from "react";
import { useAuth } from "../context/auth-context";
import { useNavigate, Link } from "react-router-dom";

export default function SignUp() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { signUp } = useAuth();

  const history = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    if (password !== confirmPassword) {
      return setError("Passwords do not match");
    }

    try {
      setLoading(true);
      setError("");
      await signUp(email, password);
      history("/");
    } catch {
      setError("Error signing up");
    }
    setLoading(false);
  }
  return (
    <>
      <div className="h-screen flex flex-col justify-start py-12 sm:px-6 lg:px-8 bg-gray-100">
        <div className="sm:mx-auto sm:w-full sm:max-w-md mt-20">
          <img
            className="mx-auto h-auto w-80 mb-12"
            src="https://onetrustmarketing.com/assets/img/OneTrustFamilyOfCompanies.png"
            alt="OneTrust Marketing"
          />
          {/* <h2 className="mt-6 text-center text-4xl font-extrabold text-teal-400">
            Sign up today
          </h2> */}
        </div>

        <div className="mt-0 sm:mx-auto sm:w-full sm:max-w-md">
          {error && <p className="text-red-500 text-center">{error}</p>}
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    ref={emailRef}
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <input
                    ref={passwordRef}
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="password-confirm"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password Confirm
                </label>
                <div className="mt-1">
                  <input
                    ref={confirmPasswordRef}
                    id="password-confirm"
                    name="password-confirm"
                    type="password"
                    autoComplete=""
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <button
                  disabled={loading}
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-primary hover:bg-blue-complimentary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                >
                  Sign up
                </button>
              </div>
            </form>
            <div className="flex items-center justify-between mt-3">
              <div className="flex items-center"></div>

              <div className="text-sm">
                <Link
                  to="/login"
                  className="font-medium text-blue-primary hover:text-blue-complimentary"
                >
                  Have an account login?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
